"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountManagement = exports.logout = exports.login = exports.initAuthentication = exports.AUTH_REFRESH_ERROR = exports.AUTH_REFRESH_SUCCESS = exports.AUTH_LOGOUT = exports.AUTH_ERROR = exports.AUTH_SUCCESS = exports.DISABLE_AUTHENTICATION = exports.AUTH_INIT = void 0;
var keycloak_js_1 = __importDefault(require("keycloak-js"));
var pick_1 = __importDefault(require("lodash/pick"));
var MIN_TOKEN_VALIDITY_SEC = 5;
exports.AUTH_INIT = 'AUTH_INITIALIZED';
exports.DISABLE_AUTHENTICATION = 'DISABLE_AUTHENTICATION';
exports.AUTH_SUCCESS = 'AUTH_SUCCESS';
exports.AUTH_ERROR = 'AUTH_ERROR';
exports.AUTH_LOGOUT = 'AUTH_LOGOUT';
exports.AUTH_REFRESH_SUCCESS = 'AUTH_REFRESH_SUCCESS';
exports.AUTH_REFRESH_ERROR = 'AUTH_REFRESH_ERROR';
function persistTokens(keycloak) {
    localStorage.setItem('tokens', JSON.stringify((0, pick_1.default)(keycloak, 'token', 'refreshToken', 'idToken')));
}
function retrieveTokens() {
    return JSON.parse(localStorage.getItem('tokens')) || {};
}
function successWithToken(type, keycloak) {
    return {
        type: type,
        token: keycloak.token,
        tokenParsed: keycloak.tokenParsed,
        idTokenParsed: keycloak.idTokenParsed,
    };
}
var initAuthentication = function (config, options, authenticationDisabled) { return function (dispatch) {
    if (authenticationDisabled) {
        dispatch({ type: exports.DISABLE_AUTHENTICATION });
        return;
    }
    // TODO: retrieve token
    var keycloak = (0, keycloak_js_1.default)(config);
    keycloak.onAuthSuccess = function () {
        persistTokens(keycloak);
        dispatch(successWithToken(exports.AUTH_SUCCESS, keycloak));
    };
    keycloak.onAuthLogout = function () {
        dispatch({ type: exports.AUTH_LOGOUT });
    };
    keycloak.onAuthError = function () {
        dispatch({ type: exports.AUTH_ERROR });
    };
    keycloak.onTokenExpired = function () {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        keycloak.updateToken(MIN_TOKEN_VALIDITY_SEC);
    };
    keycloak.onAuthRefreshSuccess = function () {
        persistTokens(keycloak);
        dispatch(successWithToken(exports.AUTH_REFRESH_SUCCESS, keycloak));
    };
    keycloak.onAuthRefreshError = function () {
        dispatch({ type: exports.AUTH_REFRESH_ERROR });
    };
    keycloak
        .init(__assign(__assign({}, options), retrieveTokens()))
        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: exports.AUTH_INIT, keycloak: keycloak });
                    if (!keycloak.authenticated) return [3 /*break*/, 2];
                    return [4 /*yield*/, keycloak.updateToken(3600)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); })
        .catch(function () {
        dispatch({ type: exports.AUTH_ERROR });
    });
}; };
exports.initAuthentication = initAuthentication;
var login = function () { return function (dispatch, getState) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getState().auth.keycloak.login();
    // No need to dispatch an action, because keycloak will redirect the user?
}; };
exports.login = login;
var logout = function () { return function (dispatch, getState) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getState().auth.keycloak.logout();
    // No need to dispatch an action, because keycloak will redirect the user?
}; };
exports.logout = logout;
var accountManagement = function () { return function (dispatch, getState) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getState().auth.keycloak.accountManagement();
    // No need to dispatch an action, because keycloak will redirect the user?
}; };
exports.accountManagement = accountManagement;
